export function getDrivingLicenseIssueYears(startYear: number) {
    const years = [];
    const endYear = new Date().getFullYear();
    while (startYear <= endYear) {
        years.push(startYear++);
    }
    return years;
}

export function getDrivingLicenseIssueMonths(year: number): any[] {
    const fullDictionary = [
        { key: 1, label: 'Styczeń' },
        { key: 2, label: 'Luty' },
        { key: 3, label: 'Marzec' },
        { key: 4, label: 'Kwiecień' },
        { key: 5, label: 'Maj' },
        { key: 6, label: 'Czerwiec' },
        { key: 7, label: 'Lipiec' },
        { key: 8, label: 'Sierpień' },
        { key: 9, label: 'Wrzesień' },
        { key: 10, label: 'Październik' },
        { key: 11, label: 'Listopad' },
        { key: 12, label: 'Grudzień' },
    ];

    const today = new Date();
    const dict = today.getFullYear() === year ? fullDictionary.filter(item => item.key <= today.getMonth() + 1) : fullDictionary

    return dict;
}
